export const showFormErrorMessage = (name, errors) => {
  return name && errors[name] ? <small className="p-error">{errors[name]?.message}</small> : null;
};
